import React from 'react';
import PropTypes from 'prop-types';
import FormTemplate from '../../../dialogs_common/SetupTemplate';
import PrimaryButton from '../../../components_setup/PrimarySetupButton';

Form.propTypes = {
  user: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrevious: PropTypes.func,
  onSkip: PropTypes.func.isRequired
};

export default function Form(props) {
  const {
    user,
    navigation,
    onNext,
    onPrevious,
    onSkip
  } = props;

  return (
    <div className="my-auto">
      <FormTemplate
        onPrevious={onPrevious}
        navigation={navigation}
        title={(
          <>
            We'll follow up to learn more about you, so you can have the best experience. In
            the meantime, feel free to explore the platform.
          </>
        )}
        footer={(
          <>
            {/*<div className="text-cs-orange-500 underline cursor-pointer mt-6 sm:mt-0 mr-0 sm:mr-12" onClick={onSkip}>*/}
            {/*  Skip this step*/}
            {/*</div>*/}
            <PrimaryButton onClick={onNext}>
              Explore
            </PrimaryButton>
          </>
        )}
      />
    </div>
  );
};
